import styled from 'styled-components';

export const ContainerAlert = styled.div`
  display: flex;
  width: 442px;
  padding: 12px;
  gap: 8px;
  border-radius: 12px;
  border-left: 4px solid ${({ colorBorder }) => colorBorder};
  background: var(--Takeat-Colors-Neutrals-White, #fff);

  /* 04 */
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
`;

export const ContainerInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const ContentIcon = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const ContainerTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

export const Title = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Title/Title Small/Semibold | 600 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 150% */
  letter-spacing: 0.15px;
`;

export const Text = styled.span`
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);

  /* Label/Label Large/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 142.857% */
  letter-spacing: 0.1px;
`;

export const OverlayHidden = styled.div`
  position: fixed;
  right: 35px;
  z-index: 9999;
  bottom: 20px;
`;
